<template>
  <v-container fluid grid-list-md fill-height class="bgPurple">
    <v-layout row wrap text-xs-center>
      <v-flex xs12>
        <v-layout row wrap fill-height>
          <!-- ERROR SNIPPET -->
          <v-snackbar
            v-model="error.show"
            color="error"
            top
            :timeout="error.timeout"
            text-xs-center
          >
            {{ error.message }}
            <v-icon right dark>error_outline</v-icon>
          </v-snackbar>

          <!-- LOGO -->
          <v-flex xs12>
            <img
              :src="
                require('@/assets/img/logo_e-egyetem_classroom_logo_white.png')
              "
              alt="logo"
              style="max-width: 250px;"
            />
          </v-flex>

          <!-- LOADER -->
          <v-flex xs12 v-show="loader">
            <v-progress-circular
              dark
              color="white"
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-flex>

          <!-- NEW PASSWORD -->
          <v-flex offset-xs2 xs8>
            <v-form>
              <v-text-field
                prepend-icon="alternate_email"
                name="login"
                label="Email cím"
                type="text"
                dark
                :rules="[rules.required]"
                v-model="form.email"
              ></v-text-field>
            </v-form>

            <v-btn color="white" x-large @click="getPinCode()" tile flat>
              Új jelszó kérése
              <!-- <v-icon right dark>input</v-icon> -->
            </v-btn>
            <v-btn color="white" x-large @click="goToLogin()" tile flat>
              Vissza
              <!-- <v-icon right dark>input</v-icon> -->
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    form: {
      email: ""
    },
    error: {
      show: false,
      code: "",
      message: ""
    },
    rules: {
      required: value => !!value || "Kötelező"
    }
  }),
  methods: {
    getPinCode() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/password/reset", {
          email: this.$data.form.email
        })
        .then(response => {
          if (
            response.data.goToPIN !== undefined &&
            response.data.goToPIN === true
          ) {
            this.$router.push({ name: "MobilePasswordResetPin" });
          }
        })
        .catch(error => {
          this.$data.error.message = error.response.data.message;
          this.$data.error.code = error.response.data.code;
          this.$data.error.show = true;
          // this.$store.commit("loginFailed", {error});
        });
    },
    goToLogin() {
      //Move to stepfield
      this.$router.push({ name: "MobileMain" });
    }
  },
  mounted() {}
};
</script>
